<div class="gray-bg" id="parametros-top">
  <div class="container padding-top-10 padding-bottom-10 parametros">
    <div class="row">
      <div class="col-xs-12">
        <div class="page-header">
          <h2>Configurações</h2>
        </div>
      </div>

      <div class="col-xs-12">
        <uib-alert ng-show="alert" type="{{alert.type}}" close="alert = null">{{alert.msg}}</uib-alert>

        <form novalidate name="loginForm" ng-submit="saveParametro(parametro)">

          <div class="ibox">
            <div class="ibox-title">
              <h5>Empresa</h5>
            </div>
            <div class="ibox-content">
              <div class="checkbox">
                <label>
                  <input type="checkbox" ng-model="parametro.nao_cliente_agrogestao"> Não é cliente AgroGestão
                </label>
              </div>

              <div class="checkbox" ng-if="parametro.nao_cliente_agrogestao">
                <label>
                  <input type="checkbox" ng-model="parametro.permite_plantio_simplificado"> Permitir plantio simplificado pelo APP Lavoura
                </label>
              </div>

              <div class="form-group row">
                <div class="col-xs-6">
                  <label class="control-label" for="logomarca">Logomarca</label>
                  <input class="form-control input-sm"
                    ng-model="parametro.logomarca"
                    id="logomarca"
                    type="file"
                    accept="image/*"
                    file-input
                    ng-change="fileNameChanged()">
                </div>
                <div class="col-xs-6" ng-show="parametro.logomarca || logomarcaUrl">
                  <img ng-src="{{parametro.logomarca || logomarcaUrl}}" class="img-responsive margin-center">
                </div>
              </div>

              <div class="form-group">
                <label class="control-label" for="modelo_relatorio_visita">Modelo Relatório de Visita</label>
                <select class="form-control input-sm"
                  ng-model="parametro.modelo_relatorio_visita"
                  id="modelo_relatorio_visita"
                  ng-options="modelo as modelo.descricao for modelo in modelosRelatorios"></select>
              </div>
            </div>
          </div>

          <div class="ibox">
            <div class="ibox-title">
              <h5>Operações</h5>
            </div>
            <div class="ibox-content">
              <div class="row">
                <div class="col-xs-6">
                  <div class="form-group">
                    <label class="control-label" for="operacao_pulverizacao">Operação de campo para pulverizações</label>
                    <select class="form-control input-sm"
                      ng-model="parametro.operacao_pulverizacao"
                      id="operacao_pulverizacao"
                      ng-options="operacao as operacao.descricao for operacao in operacoes track by operacao.id"></select>
                  </div>
                </div>
                <div class="col-xs-6">
                  <div class="list-group-item-text">
                    <div class="row">
                      <div class="col-xs-12">
                        <b>Faixas de variação de velocidade</b>
                      </div>
                      <div class="col-xs-12">
                        <slider range="true" ng-model="parametro.operacao_pulverizacao.faixas" class="slider-faixas"
                                min="0" auto-step max="100" value="parametro.operacao_pulverizacao.faixas" slider-tooltip="hide">
                        </slider>
                      </div>
                      <div class="col-xs-4 text-center">
                        <span class="bg-equilibrio padding-left-5 padding-right-5">&nbsp;</span>
                        <b> &lt;= {{parametro.operacao_pulverizacao.faixas[0]}}</b>
                      </div>
                      <div class="col-xs-4 text-center">
                        <span class="bg-controle padding-left-5 padding-right-5">&nbsp;</span>
                        <b> > {{parametro.operacao_pulverizacao.faixas[0]}} e &lt;= {{parametro.operacao_pulverizacao.faixas[1]}}</b>
                      </div>
                      <div class="col-xs-4 text-center">
                        <span class="bg-alerta padding-left-5 padding-right-5">&nbsp;</span>
                        <b> > {{parametro.operacao_pulverizacao.faixas[1]}}</b>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div class="row">
                <div class="col-xs-6">
                  <div class="form-group">
                    <label class="control-label" for="operacao_semeadura">Operação de campo para Semeadura</label>
                    <select class="form-control input-sm"
                      ng-model="parametro.operacao_semeadura"
                      id="operacao_semeadura"
                      ng-options="operacao as operacao.descricao for operacao in operacoesSemeadura track by operacao.id"></select>
                  </div>
                </div>
                <div class="col-xs-6">
                  <div class="list-group-item-text">
                    <div class="row">
                      <div class="col-xs-12">
                        <b>Faixas de variação de velocidade</b>
                      </div>
                      <div class="col-xs-12">
                        <slider range="true" ng-model="parametro.operacao_semeadura.faixas" class="slider-faixas"
                                min="0" auto-step max="100" value="parametro.operacao_semeadura.faixas" slider-tooltip="hide">
                        </slider>
                      </div>
                      <div class="col-xs-4 text-center">
                        <span class="bg-equilibrio padding-left-5 padding-right-5">&nbsp;</span>
                        <b> &lt;= {{parametro.operacao_semeadura.faixas[0]}}</b>
                      </div>
                      <div class="col-xs-4 text-center">
                        <span class="bg-controle padding-left-5 padding-right-5">&nbsp;</span>
                        <b> > {{parametro.operacao_semeadura.faixas[0]}} e &lt;= {{parametro.operacao_semeadura.faixas[1]}}</b>
                      </div>
                      <div class="col-xs-4 text-center">
                        <span class="bg-alerta padding-left-5 padding-right-5">&nbsp;</span>
                        <b> > {{parametro.operacao_semeadura.faixas[1]}}</b>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div class="row">
                <div class="col-xs-6">
                  <div class="form-group">
                    <label class="control-label" for="operacao_adubacao_base">Operação de campo para Adubação de Base</label>
                    <select class="form-control input-sm"
                      ng-model="parametro.operacao_adubacao_base"
                      id="operacao_adubacao_base"
                      ng-options="operacao as operacao.descricao for operacao in operacoesAdubacaoBase track by operacao.id"></select>
                  </div>
                </div>
                <div class="col-xs-6">
                  <div class="list-group-item-text">
                    <div class="row">
                      <div class="col-xs-12">
                        <b>Faixas de variação de velocidade</b>
                      </div>
                      <div class="col-xs-12">
                        <slider range="true" ng-model="parametro.operacao_adubacao_base.faixas" class="slider-faixas"
                                min="0" auto-step max="100" value="parametro.operacao_adubacao_base.faixas" slider-tooltip="hide">
                        </slider>
                      </div>
                      <div class="col-xs-4 text-center">
                        <span class="bg-equilibrio padding-left-5 padding-right-5">&nbsp;</span>
                        <b> &lt;= {{parametro.operacao_adubacao_base.faixas[0]}}</b>
                      </div>
                      <div class="col-xs-4 text-center">
                        <span class="bg-controle padding-left-5 padding-right-5">&nbsp;</span>
                        <b> > {{parametro.operacao_adubacao_base.faixas[0]}} e &lt;= {{parametro.operacao_adubacao_base.faixas[1]}}</b>
                      </div>
                      <div class="col-xs-4 text-center">
                        <span class="bg-alerta padding-left-5 padding-right-5">&nbsp;</span>
                        <b> > {{parametro.operacao_adubacao_base.faixas[1]}}</b>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div class="row">
                <div class="col-xs-6">
                  <div class="form-group">
                    <label class="control-label" for="operacao_correcao_solo">Operação de campo para Correcão de Solo</label>
                    <select class="form-control input-sm"
                      ng-model="parametro.operacao_correcao_solo"
                      id="operacao_correcao_solo"
                      ng-options="operacao as operacao.descricao for operacao in operacoesCorrecaoDeSolo track by operacao.id"></select>
                  </div>
                </div>
                <div class="col-xs-6">
                  <div class="list-group-item-text">
                    <div class="row">
                      <div class="col-xs-12">
                        <b>Faixas de variação de velocidade</b>
                      </div>
                      <div class="col-xs-12">
                        <slider range="true" ng-model="parametro.operacao_correcao_solo.faixas" class="slider-faixas"
                                min="0" auto-step max="100" value="parametro.operacao_correcao_solo.faixas" slider-tooltip="hide">
                        </slider>
                      </div>
                      <div class="col-xs-4 text-center">
                        <span class="bg-equilibrio padding-left-5 padding-right-5">&nbsp;</span>
                        <b> &lt;= {{parametro.operacao_correcao_solo.faixas[0]}}</b>
                      </div>
                      <div class="col-xs-4 text-center">
                        <span class="bg-controle padding-left-5 padding-right-5">&nbsp;</span>
                        <b> > {{parametro.operacao_correcao_solo.faixas[0]}} e &lt;= {{parametro.operacao_correcao_solo.faixas[1]}}</b>
                      </div>
                      <div class="col-xs-4 text-center">
                        <span class="bg-alerta padding-left-5 padding-right-5">&nbsp;</span>
                        <b> > {{parametro.operacao_correcao_solo.faixas[1]}}</b>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div class="row">
                <div class="col-xs-6">
                  <div class="form-group">
                    <label class="control-label" for="operacao_adubacao_sistema">Operação de campo para Adubação de Sistema</label>
                    <select class="form-control input-sm"
                            ng-model="parametro.operacao_adubacao_sistema"
                            id="operacao_adubacao_sistema"
                            ng-options="operacao as operacao.descricao for operacao in operacoesCorrecaoDeSolo track by operacao.id"></select>
                  </div>
                </div>
                <div class="col-xs-6">
                  <div class="list-group-item-text">
                    <div class="row">
                      <div class="col-xs-12">
                        <b>Faixas de variação de velocidade</b>
                      </div>
                      <div class="col-xs-12">
                        <slider range="true" ng-model="parametro.operacao_adubacao_sistema.faixas" class="slider-faixas"
                                min="0" auto-step max="100" value="parametro.operacao_adubacao_sistema.faixas" slider-tooltip="hide">
                        </slider>
                      </div>
                      <div class="col-xs-4 text-center">
                        <span class="bg-equilibrio padding-left-5 padding-right-5">&nbsp;</span>
                        <b> &lt;= {{parametro.operacao_adubacao_sistema.faixas[0]}}</b>
                      </div>
                      <div class="col-xs-4 text-center">
                        <span class="bg-controle padding-left-5 padding-right-5">&nbsp;</span>
                        <b> > {{parametro.operacao_adubacao_sistema.faixas[0]}} e &lt;= {{parametro.operacao_adubacao_sistema.faixas[1]}}</b>
                      </div>
                      <div class="col-xs-4 text-center">
                        <span class="bg-alerta padding-left-5 padding-right-5">&nbsp;</span>
                        <b> > {{parametro.operacao_adubacao_sistema.faixas[1]}}</b>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div class="row">
                <div class="col-xs-6">
                  <div class="form-group">
                    <label class="control-label" for="operacao_adubacao">Operação de campo para Adubação</label>
                    <select class="form-control input-sm"
                      ng-model="parametro.operacao_adubacao"
                      id="operacao_adubacao"
                      ng-options="operacao as operacao.descricao for operacao in operacoesAdubacao track by operacao.id">
                    </select>
                  </div>
                </div>
                <div class="col-xs-6">
                  <div class="list-group-item-text">
                    <div class="row">
                      <div class="col-xs-12">
                        <b>Faixas de variação de velocidade</b>
                      </div>
                      <div class="col-xs-12">
                        <slider range="true" ng-model="parametro.operacao_adubacao.faixas" class="slider-faixas"
                                min="0" auto-step max="100" value="parametro.operacao_adubacao.faixas" slider-tooltip="hide">
                        </slider>
                      </div>
                      <div class="col-xs-4 text-center">
                        <span class="bg-equilibrio padding-left-5 padding-right-5">&nbsp;</span>
                        <b> &lt;= {{parametro.operacao_adubacao.faixas[0]}}</b>
                      </div>
                      <div class="col-xs-4 text-center">
                        <span class="bg-controle padding-left-5 padding-right-5">&nbsp;</span>
                        <b> > {{parametro.operacao_adubacao.faixas[0]}} e &lt;= {{parametro.operacao_adubacao.faixas[1]}}</b>
                      </div>
                      <div class="col-xs-4 text-center">
                        <span class="bg-alerta padding-left-5 padding-right-5">&nbsp;</span>
                        <b> > {{parametro.operacao_adubacao.faixas[1]}}</b>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-xs-6">
                  <div class="form-group">
                    <label class="control-label" for="operacao_colheita">Operação de campo para Colheita</label>
                    <select class="form-control input-sm"
                      ng-model="parametro.operacao_colheita"
                      id="operacao_colheita"
                      ng-options="operacao as operacao.descricao for operacao in operacoesColheita track by operacao.id">
                    </select>
                  </div>
                </div>

                <div class="col-xs-6">
                  <div class="list-group-item-text">
                    <div class="row">
                      <div class="col-xs-12">
                        <b>Faixas de variação de velocidade</b>
                      </div>
                      <div class="col-xs-12">
                        <slider range="true" ng-model="parametro.operacao_colheita.faixas" class="slider-faixas"
                                min="0" auto-step max="100" value="parametro.operacao_colheita.faixas" slider-tooltip="hide">
                        </slider>
                      </div>
                      <div class="col-xs-4 text-center">
                        <span class="bg-equilibrio padding-left-5 padding-right-5">&nbsp;</span>
                        <b> &lt;= {{parametro.operacao_colheita.faixas[0]}}</b>
                      </div>
                      <div class="col-xs-4 text-center">
                        <span class="bg-controle padding-left-5 padding-right-5">&nbsp;</span>
                        <b> > {{parametro.operacao_colheita.faixas[0]}} e &lt;= {{parametro.operacao_colheita.faixas[1]}}</b>
                      </div>
                      <div class="col-xs-4 text-center">
                        <span class="bg-alerta padding-left-5 padding-right-5">&nbsp;</span>
                        <b> > {{parametro.operacao_colheita.faixas[1]}}</b>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="ibox">
            <div class="ibox-title">
              <h5>Caminhamento</h5>
            </div>
            <div class="ibox-content">
              <div class="checkbox">
                <label>
                  <input type="checkbox" ng-model="parametro.caminhamento.alta_precisao"> Caminhamento com alta precisão no aplicativo
                  <p class="help-block">Atenção, esta opção gera um alto consumo de bateria pelo aplicativo!</p>
                </label>
              </div>

              <a class="pointer" ng-show="parametro.caminhamento.alta_precisao"
                    ng-click="caminhamento_avancado = !caminhamento_avancado">Exibir Opções avançadas</a><br>

              <div class="row" ng-show="parametro.caminhamento.alta_precisao && caminhamento_avancado">
                <div class="form-group col-xs-4">
                  <label for="caminhamento_distancia_minima">Distância Mínima (metros)</label>
                  <input class="form-control input-sm" type="number" id="caminhamento_distancia_minima"
                    ng-model="parametro.caminhamento.distancia_minima">
                </div>

                <div class="form-group col-xs-4">
                  <label for="caminhamento_velocidade_maxima">Velocidade Máxima (km/h)</label>
                  <input class="form-control input-sm" type="number" id="caminhamento_velocidade_maxima"
                    ng-model="parametro.caminhamento.velocidade_maxima">
                </div>

                <div class="form-group col-xs-4" ng-show="parametro.caminhamento.alta_precisao && caminhamento_avancado">
                  <label for="caminhamento_intervalo">Intervalo (segundos)</label>
                  <input class="form-control input-sm" type="number"
                    id="caminhamento_intervalo"
                    ng-model="parametro.caminhamento.intervalo">
                </div>
              </div>
            </div>
          </div>

          <div class="ibox">
            <div class="ibox-title">
              <h5>Visitas</h5>
            </div>
            <div class="ibox-content">
              <div class="row">
                <div class="form-group col-xs-6">
                  <label for="tempo_minimo_visita" class="control-label">Tempo mínimo de visita</label>
                  <div class="input-group">
                    <input type="number" class="form-control input-sm" id="tempo_minimo_visita" ng-model="parametro.tempo_minimo_visita">
                    <span class="input-group-addon">minutos</span>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="ibox">
            <div class="ibox-title">
              <h5>Estoques</h5>
            </div>
            <div class="ibox-content">
              <div class="checkbox" ng-if="false">
                <label>
                  <input type="checkbox" ng-model="parametro.aplicacao_precisa_confirmacao_para_estoque"> Aplicação precisa de confirmação para baixar estoque?
                </label>
              </div>
              <div class="checkbox">
                <label>
                  <input type="checkbox" ng-model="parametro.tem_controle_de_estoque"> Aplicação deve exibir controle de Estoque?
                </label>
              </div>
              <div class="checkbox">
                <label>
                  <input type="checkbox" ng-model="parametro.utiliza_deposito_padrao"> Utilizar sempre depósito padrão da propriedade?
                </label>
              </div>
            </div>
          </div>

          <div class="ibox">
            <div class="ibox-title">
              <h5>Preferências</h5>
            </div>
            <div class="ibox-content">
              <div class="checkbox">
                <label>
                  <input type="checkbox" ng-model="parametro.tarefas_com_precisao"> Realizar tarefas apenas nos pontos previstos?
                </label>
              </div>

              <div class="row" ng-if="parametro.tarefas_com_precisao">
                <div class="form-group col-xs-6">
                  <label class="control-label" for="tamanho_maximo_raio_tarefa">
                    Distância máxima para a realização da tarefa no ponto previsto
                  </label>
                  <div class="input-group">
                    <input class="form-control input-sm" type="number" id="tamanho_maximo_raio_tarefa"
                          ng-model="parametro.tamanho_maximo_raio_tarefa">
                    <span class="input-group-addon">metros</span>
                  </div>
                </div>
              </div>

              <div class="checkbox">
                <label>
                  <!-- Nome do parametro (controla_custo_insumo) não foi alterado propositalmente, apenas o texto exibido foi ajustado -->
                  <input type="checkbox" ng-model="parametro.controla_custo_insumo"> Controlar custo por cultivar?
                </label>
              </div>

              <div class="checkbox">
                <label>
                  <input type="checkbox" ng-model="parametro.bloquear_alteracao_dose"> Bloquear alteração de dose na aplicação?
                </label>
              </div>

              <div class="checkbox">
                <label>
                  <input type="checkbox" ng-model="parametro.usoAcompanhado">Aplicativo deve marcar "Uso Acompanhado" por padrão?
                </label>
              </div>

              <div class="checkbox">
                <label>
                  <input type="checkbox" ng-model="parametro.desabilitarPulverizacoesAppLavoura">Desabilitar pulverizações no APP Aqila Lavoura
                </label>
              </div>

              <div class="checkbox">
                <label>
                  <input type="checkbox" ng-model="parametro.desabilitarBOAppLavoura">Desabilitar B.O. de Máquinas no APP Aqila Lavoura
                </label>
              </div>

              <div class="checkbox">
                <label>
                  <input type="checkbox" ng-model="parametro.obrigarUsoMaquina">Obrigar o registro de uso de máquina após aplicações
                </label>
              </div>
              <div class="checkbox">
                <label>
                  <input type="checkbox" ng-model="parametro.bloquear_gasto_combustivel"> Bloquear lançamento de consumo de combustível?
                </label>
              </div>

              <div class="checkbox">
                <label>
                  <input type="checkbox" ng-model="parametro.encerrar_aplicacao_automaticamente"> Encerrar recomendação automaticamente a partir de 98% de conclusão?
                </label>
              </div>

              <div class="checkbox">
                <label>
                  <input type="checkbox" ng-model="parametro.ativar_camera_aqila"> Ativar câmera Aqila?
                </label>
              </div>

              <div class="checkbox">
                <label>
                  <input type="checkbox" ng-model="parametro.obrigar_talhao_uso_maquina"> Obrigar talhão nos usos de máquinas?
                </label>
              </div>

              <div class="checkbox">
                <label>
                  <input type="checkbox" ng-model="parametro.feature_decimal_v2"> Padronizar casas decimais com o APP Aqila?
                </label>
              </div>

              <div class="row">
                <div class="form-group col-xs-6">
                  <label class="control-label" for="percentual_recomendado_aplicado">
                    Percentual de Tolerância para comparação de Dose no Recomendado vs. Aplicado
                  </label>
                  <input class="form-control input-sm" type="number" id="percentual_recomendado_aplicado"
                        ng-model="parametro.percentual_recomendado_aplicado">
                </div>
              </div>

              <div class="row">
                <div class="form-group col-xs-6">
                  <label class="control-label" for="paginacao_envio">
                    Número máximo de registros por envio
                  </label>
                  <input class="form-control input-sm" type="number" id="paginacao_envio"
                        ng-model="parametro.paginacao_envio">
                </div>
              </div>

              <div class="row">
                <div class="form-group col-xs-12">
                  <label class="control-label" for="formula_centro_custos">
                    Fórmula para obtenção de centro de custos
                    <i ng-if="$root.isMasterUser()" class="icon-info text-muted" aria-hidden="true" uib-tooltip="Escrever fórmula em Ruby. Utilizar @params para acessar os parâmetros de entrada. Para visualizar os parâmetro de entrada basta clicar em Testar fórmula" tooltip-placement="bottom"></i>
                  </label>
                  <textarea rows="10" ng-disabled="!$root.isMasterUser()" class="form-control" id="formula_centro_custos" ng-model="parametro.formula_centro_custos"></textarea>
                  <small ng-if="!$root.isMasterUser()">Somente usuário inovacao pode editar esse registros</small>
                  <a ng-if="$root.isMasterUser()" prevent-event href="#" ng-click="testFormula()">Testar fórmula</a>
                </div>
              </div>
            </div>
          </div>

          <div class="ibox">
            <div class="ibox-title">
              <h5>Unidades de Medida</h5>
            </div>
            <div class="ibox-content">
              <div class="row">
                <div class="form-group col-xs-6">
                  <label class="control-label" for="quilograma">Unidade de medida que representa quilograma</label>
                  <select class="form-control input-sm"
                    ng-model="parametro.unidade_quilograma"
                    id="quilograma"
                    ng-options="unidade as unidade.descricao for unidade in unidades track by unidade.id"></select>
                </div>

                <div class="form-group col-xs-6">
                  <label class="control-label" for="grama">Unidade de medida que representa grama</label>
                  <select class="form-control input-sm"
                    ng-model="parametro.unidade_grama"
                    id="grama"
                    ng-options="unidade as unidade.descricao for unidade in unidades track by unidade.id"></select>
                </div>
              </div>

              <div class="row">
                <div class="form-group col-xs-6">
                  <label class="control-label" for="litro">Unidade de medida que representa litro</label>
                  <select class="form-control input-sm"
                    ng-model="parametro.unidade_litro"
                    id="litro"
                    ng-options="unidade as unidade.descricao for unidade in unidades track by unidade.id"></select>
                </div>

                <div class="form-group col-xs-6">
                  <label class="control-label" for="mililitro">Unidade de medida que representa mililitro</label>
                  <select class="form-control input-sm"
                    ng-model="parametro.unidade_mililitro"
                    id="mililitro"
                    ng-options="unidade as unidade.descricao for unidade in unidades track by unidade.id"></select>
                </div>
              </div>
              <div class="row">
                <div class="form-group col-xs-6">
                  <label class="control-label" for="litro">Unidade de medida que representa sacos de milho</label>
                  <select class="form-control input-sm"
                    ng-model="parametro['unidade_saco semente milho']"
                    id="unidade_scm"
                    ng-options="unidade as unidade.descricao for unidade in unidades track by unidade.id"></select>
                </div>

                <div class="form-group col-xs-6">
                  <label class="control-label" for="litro">Unidade de medida que representa unidade</label>
                  <select class="form-control input-sm"
                    ng-model="parametro.unidade_unidade"
                    id="unidade"
                    ng-options="unidade as unidade.descricao for unidade in unidades track by unidade.id"></select>
                </div>

                <div class="form-group col-xs-6">
                  <label class="control-label" for="litro">Unidade de medida que representa tonelada</label>
                  <select class="form-control input-sm"
                    ng-model="parametro.unidade_tonelada"
                    id="unidade_ton"
                    ng-options="unidade as unidade.descricao for unidade in unidades track by unidade.id"></select>
                </div>
              </div>
            </div>
          </div>

          <div class="ibox">
            <div class="ibox-title">
              <h5>Integração Monitoramento GPS</h5>
            </div>
            <div class="ibox-content">
              <div class="checkbox">
                <label>
                  <input type="checkbox" ng-model="parametro.temIntegracaoGPS">Integração com monitoramento GPS
                </label>
              </div>

              <a class="pointer" ng-show="parametro.temIntegracaoGPS"
                    ng-click="exibirOpcoesIntegracao = !exibirOpcoesIntegracao">Exibir Opções avançadas</a><br>

              <div class="row" ng-show="parametro.temIntegracaoGPS && exibirOpcoesIntegracao">
                <div ng-show="parametro.integracao_gps.tipo != 'agritel'">
                  <div class="form-group col-xs-4">
                    <label for="integracao_gps_login">Login</label>
                    <input class="form-control input-sm" type="text" id="integracao_gps_login"
                      ng-model="parametro.integracao_gps.login">
                  </div>

                  <div class="form-group col-xs-4">
                    <label for="integracao_gps_senha">Senha</label>
                    <input class="form-control input-sm" type="password" id="integracao_gps_senha"
                      ng-model="parametro.integracao_gps.senha">
                  </div>

                  <div class="form-group col-xs-4">
                    <label for="integracao_gps_url">URL do serviço</label>
                    <input class="form-control input-sm" type="text" id="integracao_gps_url"
                      ng-model="parametro.integracao_gps.url">
                  </div>

                  <div class="form-group col-xs-4">
                    <label for="integracao_gps_application_id">Application ID</label>
                    <input class="form-control input-sm" type="text" id="integracao_gps_application_id"
                      ng-model="parametro.integracao_gps.application_id">
                  </div>
                </div>

                <div ng-show="parametro.integracao_gps.tipo == 'agritel'">
                  <div class="form-group col-xs-4">
                    <label for="integracao_gps_key">Key</label>
                    <input class="form-control input-sm" type="text" id="integracao_gps_key"
                      ng-model="parametro.integracao_gps.key">
                  </div>
                </div>

                <div class="form-group col-xs-4">
                  <label class="control-label">Empresa</label>
                  <select class="form-control input-sm" ng-model="parametro.integracao_gps.tipo">
                    <option value="rastro">Rastro Rastreamento</option>
                    <option value="wolf">Wolf Rastreamento</option>
                    <option value="agritel">Agritel</option>
                    <option value="agrothings">Agrothings</option>
                  </select>
                </div>
              </div>
            </div>
          </div>


          <div class="padding-bottom-10 text-right">
            <div class="btn-group">
              <button class="btn btn-default btn-action" ng-click="init()">Cancelar</button>

              <button class="btn btn-success btn-action" ng-if="permissions.parametro.canManage" type="submit">
                Salvar <i class="fa fa-check"></i>
              </button>
            </div>
          </div>
        </form>

        <hr>

        <div class="ibox" id="contrato">
          <div class="ibox-title">
            <h5>Informações do Contrato</h5>
            <div class="ibox-tools">
              <a ng-click="updateContrato()">
                <i class="fa fa-refresh"></i>
                Atualizar Contrato
              </a>
            </div>
          </div>
          <div class="ibox-content">
            <p class="lead">Áreas</p>
            <div class="row">
              <div class="col-xs-2">
                {{contrato.area_monitorada | number:1}} ha <br>
                <strong>Monitorada</strong>
              </div>
              <div class="col-xs-8">
                <div class="progress">
                  <div class="progress-bar" ng-style="progressAreaContratada('style')" ng-class="progressAreaContratada('class')"></div>
                </div>
              </div>
              <div class="col-xs-2">
                <span ng-if="contrato.area_maxima">{{contrato.area_maxima | number:1}} ha</span>
                <span ng-if="!contrato.area_maxima">Indefinida</span> <br>
                <strong>Contratada</strong>
              </div>
            </div>
            <hr>
            <p class="lead">Datas</p>
            <p>
              <strong>Data de vencimento do contrato:</strong>
              {{(contrato.data_vencimento_contrato | date:'dd/MM/yyyy') || 'Indefinida'}}
            </p>
            <hr>
            <p class="lead">Módulos</p>
            <div class="row">
              <div class="col-xs-6" ng-repeat="modulo in contrato.modulos track by modulo.id">
                <div class="widget navy-bg">
                  <h3>{{modulo.descricao | capitalize}}</h3>
                  <ul>
                    <li ng-repeat="item in modulo.itens track by $index">{{item.descricao | capitalize}}</li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="ibox" id="usages">
          <div class="ibox-title">
            <h5>Estatísticas de uso dos últimos 90 dias</h5>
          </div>
          <div class="ibox-content">
            <usage-statistics></usage-statistics>
          </div>
        </div>
        <historico-alteracoes id="{{parametro.id}}" type="AppParametro" title="Alterações Parâmetros" />
      </div>
    </div>
  </div>
</div>
